import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import Header from "../Header/Header";
import { getfaqs } from "../../../api/apimethods";
import { IFaq } from "../../../typings/models/IFaq";
import { FaExternalLinkAlt } from "react-icons/fa";

const ExternalLinkIcon = FaExternalLinkAlt as React.ElementType;

function UserGuides() {
  const [faqs, setFaqs] = useState<IFaq[]>([]);

  useEffect(() => {
    getfaqs().then((response) => {
      setFaqs(response.data);
    });
  }, []);

  const getDocumentLink = (attachmentName: string, attachmentData: string) => {
    try {
      const byteCharacters = atob(attachmentData);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: "application/pdf" });
      const url = URL.createObjectURL(blob);
      const handleIconClick = () => {
        window.open(url, "_blank", "noopener,noreferrer");
      };

      return (
        <div>
          <a href={url} className="Textdecoration" download={attachmentName}>
            {attachmentName}
          </a>
          <ExternalLinkIcon
            onClick={handleIconClick}
            className="faexternal"
            title="Open in new window"
          />
        </div>
      );
    } catch (error) {
      console.error("Error generating document link:", error);
      return <span>Error generating link</span>;
    }
  };

  const renderGuideSection = (
    title: string,
    documentType: number
  ) => {
    const filteredFaqs = faqs.filter((faq) => faq.documentType === documentType);

    if (filteredFaqs.length === 0) return null;

    return (
      <div className="guide-item">
        <h3>{title}</h3>
        <hr />
        {filteredFaqs.map((faq) => (
          <div key={faq.faqId}>
            {getDocumentLink(faq.faqName, faq.attachmentData)}
          </div>
        ))}
      </div>
    );
  };

  return (
    <>
      <Header />
      <div className="info-content">
        <div className="user-guides-container">
          {renderGuideSection("Registration and Login", 1)}
          {renderGuideSection("Laboratory Application for CAVS Laboratory Services", 2)}
          {renderGuideSection("Laboratory Application for Plant Health Diagnostics Services", 3)}
          {renderGuideSection("Make Payment", 4)}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default UserGuides;
